import type { Contact, Conversation } from '@/views/people/lib/data';

export const defJamContacts = [
  {
    id: 'dj-c-1',
    name: 'Tunji Balogun',
    role: 'CEO',
    company: 'Def Jam Recordings',
    email: 'tunji@defjam.com',
    phone: '+1 (212) 333-8000',
    location: 'New York, NY',
    avatar: undefined,
    tags: ['Executive', 'Leadership'],
    lastContact: '1 day ago',
    isStarred: true,
    type: 'organization',
  },
  {
    id: 'dj-c-2',
    name: 'Jeff Harleston',
    role: 'Chairman & General Counsel',
    company: 'Def Jam Recordings',
    email: 'jeff.harleston@defjam.com',
    phone: '+1 (212) 333-8001',
    location: 'New York, NY',
    avatar: undefined,
    tags: ['Executive', 'Legal'],
    lastContact: '3 days ago',
    isStarred: true,
    type: 'organization',
  },
  {
    id: 'dj-c-3',
    name: 'Nicole Billings',
    role: 'SVP, A&R',
    company: 'Def Jam Recordings',
    email: 'nicole.billings@defjam.com',
    phone: '+1 (212) 333-8002',
    location: 'New York, NY',
    avatar: undefined,
    tags: ['A&R', 'Talent'],
    lastContact: '2 hours ago',
    isStarred: true,
    type: 'organization',
  },
  {
    id: 'dj-c-4',
    name: 'Kecia Tatum',
    role: 'VP, Legal & Business Affairs',
    company: 'Def Jam Recordings',
    email: 'kecia.tatum@defjam.com',
    phone: '+1 (212) 333-8003',
    location: 'New York, NY',
    avatar: undefined,
    tags: ['Legal', 'Contracts'],
    lastContact: '1 day ago',
    isStarred: true,
    type: 'organization',
  },
  {
    id: 'dj-c-5',
    name: 'Marcus Reynolds',
    role: 'Head of Finance',
    company: 'Def Jam Recordings',
    email: 'marcus.reynolds@defjam.com',
    phone: '+1 (212) 333-8004',
    location: 'New York, NY',
    avatar: undefined,
    tags: ['Finance', 'Operations'],
    lastContact: '5 days ago',
    isStarred: false,
    type: 'organization',
  },
  {
    id: 'dj-c-6',
    name: 'Sasha Robinson',
    role: 'A&R Coordinator',
    company: 'Def Jam Recordings',
    email: 'sasha.robinson@defjam.com',
    phone: '+1 (212) 333-8005',
    location: 'New York, NY',
    avatar: undefined,
    tags: ['A&R', 'Talent'],
    lastContact: '4 days ago',
    isStarred: false,
    type: 'organization',
  },
  {
    id: 'dj-c-7',
    name: 'Sir Lucian Grainge',
    role: 'Chairman & CEO',
    company: 'Universal Music Group',
    email: 'lucian.grainge@umusic.com',
    phone: '+1 (310) 865-5000',
    location: 'Santa Monica, CA',
    avatar: undefined,
    tags: ['UMG', 'Executive', 'Leadership'],
    lastContact: '2 weeks ago',
    isStarred: true,
    type: 'network',
  },
  {
    id: 'dj-c-8',
    name: 'Gee Roberson',
    role: 'Talent Manager',
    company: 'Blueprint Group',
    email: 'gee@blueprintgrp.com',
    phone: '+1 (212) 974-4400',
    location: 'New York, NY',
    avatar: undefined,
    tags: ['Management', 'Artists', 'Deals'],
    lastContact: '6 days ago',
    isStarred: false,
    type: 'network',
  },
  {
    id: 'dj-c-9',
    name: 'Richard Feldstein',
    role: 'Entertainment Attorney',
    company: 'Grubman Shire Meiselas & Sacks',
    email: 'rfeldstein@grubmanshire.com',
    phone: '+1 (212) 554-0400',
    location: 'New York, NY',
    avatar: undefined,
    tags: ['Legal', 'Outside Counsel', 'Contracts'],
    lastContact: '4 days ago',
    isStarred: true,
    type: 'network',
  },
  {
    id: 'dj-c-10',
    name: 'Coco Jones',
    role: 'Recording Artist',
    company: 'Def Jam Recordings',
    email: 'mgmt@cocojones.com',
    phone: '+1 (215) 555-0100',
    location: 'Philadelphia, PA',
    avatar: undefined,
    tags: ['Artist', 'Hip-Hop'],
    lastContact: '2 hours ago',
    isStarred: true,
    type: 'network',
  },
  {
    id: 'dj-c-11',
    name: 'Justin Bieber',
    role: 'Recording Artist',
    company: 'Def Jam Recordings',
    email: 'mgmt@justinbieber.com',
    phone: '+1 (310) 555-0200',
    location: 'Los Angeles, CA',
    avatar: undefined,
    tags: ['Artist', 'Pop'],
    lastContact: '5 hours ago',
    isStarred: true,
    type: 'network',
  },
  {
    id: 'dj-c-12',
    name: 'Tiffany Kumar',
    role: 'Brand Partnerships Director',
    company: 'Nike',
    email: 'tiffany.kumar@nike.com',
    phone: '+1 (503) 671-6453',
    location: 'Portland, OR',
    avatar: undefined,
    tags: ['Brand', 'Partnerships', 'Marketing'],
    lastContact: '10 days ago',
    isStarred: false,
    type: 'network',
  },
] satisfies Contact[];

export const defJamConversations = [
  {
    id: 'dj-conv-people-1',
    contactId: 'dj-c-4',
    contactName: 'Kecia Tatum',
    avatar: undefined,
    lastMessage: 'The Coco Jones recording deal is ready for your final pass. I updated the territory carve-out.',
    timestamp: '2 hours ago',
    unread: 2,
  },
  {
    id: 'dj-conv-people-2',
    contactId: 'dj-c-3',
    contactName: 'Nicole Billings',
    avatar: undefined,
    lastMessage: 'A&R is aligned on the Bieber amendment and the Phil The Keys producer deal.',
    timestamp: '5 hours ago',
    unread: 1,
  },
  {
    id: 'dj-conv-people-3',
    contactId: 'dj-c-2',
    contactName: 'Jeff Harleston',
    avatar: undefined,
    lastMessage: 'Legal approved the amendment. We can move it to execution this week.',
    timestamp: '1 day ago',
    unread: 0,
  },
  {
    id: 'dj-conv-people-4',
    contactId: 'dj-c-10',
    contactName: 'Coco Jones',
    avatar: undefined,
    lastMessage: 'My team is good with the touring split. Let me know when the next draft is ready.',
    timestamp: '1 day ago',
    unread: 1,
  },
] satisfies Conversation[];
